import {
  Sheet,
  SheetBody,
  SheetContent,
  SheetHeader,
  SheetTrigger,
} from '@/src/packages/components/ui/Sheet';
import { useProductContext } from '@/src/packages/components/pages/Product/ProductContext';
import { ProductDetail } from '@/src/packages/components/pages/Product/ProductDetails/ProductDetail';
import { ProductDetailTrigger } from '@/src/packages/components/pages/Product/ProductDetails/ProductDetailTrigger';
import { Box } from '@/src/packages/components/ui/Box';
import { Heading } from '@/src/packages/components/ui/Heading';
import { RichText } from '@/src/packages/components/ui/RichText';
import { RichTextConfigArticle } from '@/src/packages/components/ui/RichText/RichText.config';
import Image from 'next/image';
import { Stack } from '@/src/packages/components/ui/Stack';
import { Divider } from '@/src/packages/components/ui/Divider';
import { Book } from 'lucide-react';

export const ProductDetailCareGuides = () => {
  const {
    productVariant: { careGuides },
  } = useProductContext();

  return (
    <ProductDetail>
      <Sheet>
        <SheetTrigger asChild>
          <ProductDetailTrigger icon={Book}>
            Care instructions
          </ProductDetailTrigger>
        </SheetTrigger>
        <SheetContent>
          <SheetHeader title="Care instructions" />
          <SheetBody>
            <Stack divider={<Divider />} spaceY={10}>
              {careGuides?.map((guide, i) => {
                return (
                  <Box key={i}>
                    {guide.fields.cover && (
                      <Box className="relative aspect-video" marginBottom={4}>
                        <Image
                          src={guide.fields.cover?.fields.file.url}
                          alt=""
                          fill
                          className="object-cover"
                        />
                        <Box className="absolute flex h-full w-full items-center justify-center text-white">
                          <Heading as="h3" className="text-3xl font-medium">
                            {guide.fields.name}
                          </Heading>
                        </Box>
                      </Box>
                    )}

                    <RichText
                      data={guide.fields.content}
                      options={RichTextConfigArticle}
                    />
                  </Box>
                );
              })}
            </Stack>
          </SheetBody>
        </SheetContent>
      </Sheet>
    </ProductDetail>
  );
};
